import { render, staticRenderFns } from "./OnboardingTutorial.vue?vue&type=template&id=37ef45a3&scoped=true&"
import script from "./OnboardingTutorial.vue?vue&type=script&lang=js&"
export * from "./OnboardingTutorial.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTutorial.vue?vue&type=style&index=0&id=37ef45a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef45a3",
  null
  
)

export default component.exports